import FeathersApp, { Service } from '../Feathers';
// import { User } from '../server-interface';

export const userFeathersService: any = FeathersApp.service(Service.User);

export const createUser = (data: Partial<any>): Promise<any> => (
  userFeathersService.create(data)
);
